module.exports = __webpack_public_path__ + "static/media/reverted-icon.a50010f0.svg";